import * as React from 'react';
import { AdminSettingsSection } from '../../../components/settings/models';
import { PersonalSettingsSection } from '../../../components/settings/PersonalSettings/models';
import { ISettingsContext, SettingsContext } from '../../../containers/Settings/context';

export const SettingsContextProvider: React.FC<
	React.PropsWithChildren<{
		value?: Partial<ISettingsContext>;
	}>
> = ({ children, value: externalValue }) => {
	const value = React.useRef<ISettingsContext>({
		supportedAdminSettingsSections: [AdminSettingsSection.Company, AdminSettingsSection.UsersAndBilling],
		supportedPersonalSettingsSections: [
			PersonalSettingsSection.Profile,
			PersonalSettingsSection.Security,
			PersonalSettingsSection.EmailSignature,
			PersonalSettingsSection.Notifications,
			PersonalSettingsSection.SocialMedia,
		],
		...(externalValue || {}),
	}).current;
	return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};
